import { action } from 'typesafe-actions';
import { LoginActionTypes, TermsAcceptance } from './types';
import { LoginObj } from 'types';

export const fetchAuthRequest = (req?: LoginObj | null) =>
  action(LoginActionTypes.FETCH_REQUEST, req);

export const fetchAuthSuccess = (data?: any) =>
  action(LoginActionTypes.FETCH_SUCCESS, data);

export const fetchAuthFailure = (errors?: string | null) =>
  action(LoginActionTypes.AUTH_FAILURE, errors);

export const fetchTermsAcceptance = (request: TermsAcceptance) =>
  action(LoginActionTypes.ACCEPT_SIGNIN_TERMS, request);

export const fetchTermsAcceptanceSuccess = (res: string) =>
  action(LoginActionTypes.ACCEPT_SIGNIN_TERMS_SUCCESS, res);

export const fetchTermsAcceptanceFailure = (errors: string | null) =>
  action(LoginActionTypes.ACCEPT_SIGNIN_TERMS_FAILURE, errors);

export const fetchSelectSessionOrgRole = (orgId: number) =>
  action(LoginActionTypes.SELECT_SESSION_ORG_ROLE, orgId);

export const fetchSelectSessionOrgRoleSuccess = (res: any) =>
  action(LoginActionTypes.SELECT_SESSION_ORG_ROLE_SUCCESS, res);

export const fetchSelectSessionOrgRoleFailure = (error: any) =>
  action(LoginActionTypes.SELECT_SESSION_ORG_ROLE_FAILURE, error);

export const fetchOTPStatus = (data?: any) =>
  action(LoginActionTypes.FETCH_OTP_STATUS, data);

export const fetchOTPCode = (payload: string) =>
  action(LoginActionTypes.FETCH_OTP_CODE, payload);

export const fetchOTPCodeSuccess = (data: boolean) =>
  action(LoginActionTypes.FETCH_OTP_CODE_SUCCESS, data);

export const fetchOTPCodeFailure = (error: any) =>
  action(LoginActionTypes.FETCH_OTP_CODE_FAILURE, error);

export const signInWithOTPCode = (payload: object) =>
  action(LoginActionTypes.SIGN_IN_WITH_OTP_CODE, payload);

export const signInWithOTPCodeSuccess = (data: any) =>
  action(LoginActionTypes.SIGN_IN_WITH_OTP_CODE_SUCCESS, data);

export const signInWithOTPCodeFailure = (error?: string | null) =>
  action(LoginActionTypes.SIGN_IN_WITH_OTP_CODE_FAILURE, error);

export const signInWithTemporaryCode = (payload: object) =>
  action(LoginActionTypes.SIGN_IN_WITH_TEMPORARY_CODE, payload);

export const signInWithTemporaryCodeSuccess = (data: any) =>
  action(LoginActionTypes.SIGN_IN_WITH_TEMPORARY_CODE_SUCCESS, data);

export const signInWithTemporaryCodeFailure = (error?: string | null) =>
  action(LoginActionTypes.SIGN_IN_WITH_TEMPORARY_CODE_FAILURE, error);

export const resetLoginError = () => action(LoginActionTypes.RESET_ERROR);

export const signInForExternalApp = (payload: object) =>
  action(LoginActionTypes.SIGN_IN_FOR_EXTERNAL_APP, payload);

export const signInForExternalAppSuccess = (data: any) =>
  action(LoginActionTypes.SIGN_IN_FOR_EXTERNAL_APP_SUCCESS, data);

export const signInForExternalAppFailure = (error?: string | null) =>
  action(LoginActionTypes.SIGN_IN_FOR_EXTERNAL_APP_FAILURE, error);
